var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.14,
    height: 23.14,
    viewBox: "0 0 23.14 23.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_237525-removebg-preview",
    "data-name": "237525-removebg-preview",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57676",
    "data-name": "Group 57676",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379274",
    "data-name": "Path 379274",
    d: "M8.062-.5h1.62a18.585,18.585,0,0,1,6.2,1.18A5.646,5.646,0,0,1,17.9,2.045a2.09,2.09,0,0,1,.37.74q.035,2.707.023,5.415H16.855q.012-1.574-.023-3.147a8.165,8.165,0,0,1-1.921.833.211.211,0,0,0-.231.093A22.059,22.059,0,0,1,7.506,6.7a18.458,18.458,0,0,1-3.98-.625,1.017,1.017,0,0,0-.463-.139A.515.515,0,0,0,2.74,5.84a15.424,15.424,0,0,1-1.8-.74q0,1.192.023,2.36a1.516,1.516,0,0,0,.717.671A13.667,13.667,0,0,0,6.72,9.519q1.156.077,2.314.116h.555v1.388a1.185,1.185,0,0,0-.463.046,20.5,20.5,0,0,1-6.757-1A9.589,9.589,0,0,1,.981,9.4,20.882,20.882,0,0,0,.958,11.81a.715.715,0,0,0,.255.347,9.78,9.78,0,0,0,3.795,1.435q.88.15,1.759.255a6.964,6.964,0,0,0,1.388.093v1.388H7a.407.407,0,0,0-.185-.069q-.485-.046-.972-.069A13.4,13.4,0,0,1,.981,13.754a20.088,20.088,0,0,0-.023,2.36,1.206,1.206,0,0,0,.208.347A7.816,7.816,0,0,0,3.9,17.688q.855.2,1.712.37a11.535,11.535,0,0,0,2.314.231,15.029,15.029,0,0,0,1.666.046v1.388A20.528,20.528,0,0,1,5.7,19.539a.9.9,0,0,0-.509-.093,12.941,12.941,0,0,1-3.98-1.226A5.22,5.22,0,0,1-.107,17.179,2.357,2.357,0,0,1-.5,16.392V2.878A2.331,2.331,0,0,1,.333,1.606,7.464,7.464,0,0,1,2.647.426,1.017,1.017,0,0,0,3.11.287,18.913,18.913,0,0,1,8.062-.5ZM14.68,4.452a1.714,1.714,0,0,0-.6.185q-.608.117-1.2.278a4.617,4.617,0,0,0-.74.139A23.5,23.5,0,0,1,5.979,5.1a2.7,2.7,0,0,0-.463-.093H5.377L4.359,4.776A2.488,2.488,0,0,0,3.9,4.683a.525.525,0,0,0-.231-.093,8.557,8.557,0,0,1-2.314-1,1.323,1.323,0,0,1-.37-.463A.815.815,0,0,1,1.3,2.67a9.73,9.73,0,0,1,2.962-1.2,21.124,21.124,0,0,1,8.654-.139,12.623,12.623,0,0,1,3.147,1.064,1.965,1.965,0,0,1,.787.717,1.792,1.792,0,0,1-.694.671A10.544,10.544,0,0,1,14.68,4.452Z",
    transform: "translate(0.5 0.5)",
    fill: "#",
    fillRule: "evenodd",
    opacity: 0.997,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57677",
    "data-name": "Group 57677",
    transform: "translate(2.647 0.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379275",
    "data-name": "Path 379275",
    d: "M67.963,16.5a1.017,1.017,0,0,1-.463.139A1.017,1.017,0,0,1,67.963,16.5Z",
    transform: "translate(-67.5 -16.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.816,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57678",
    "data-name": "Group 57678",
    transform: "translate(14.078 4.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379276",
    "data-name": "Path 379276",
    d: "M315.1,106.5a1.714,1.714,0,0,1-.6.185A1.714,1.714,0,0,1,315.1,106.5Z",
    transform: "translate(-314.5 -106.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.863,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57679",
    "data-name": "Group 57679",
    transform: "translate(3.665 4.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379277",
    "data-name": "Path 379277",
    d: "M89.5,109.5a.525.525,0,0,1,.231.093A.211.211,0,0,1,89.5,109.5Z",
    transform: "translate(-89.5 -109.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.58,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57680",
    "data-name": "Group 57680",
    transform: "translate(4.359 4.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379278",
    "data-name": "Path 379278",
    d: "M104.5,113.5l1.018.231a3.868,3.868,0,0,1-.787-.116A.291.291,0,0,1,104.5,113.5Z",
    transform: "translate(-104.5 -113.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.808
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57681",
    "data-name": "Group 57681",
    transform: "translate(12.134 4.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379279",
    "data-name": "Path 379279",
    d: "M273.241,116.5a1.569,1.569,0,0,1-.74.139A4.617,4.617,0,0,1,273.241,116.5Z",
    transform: "translate(-272.5 -116.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.918,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57682",
    "data-name": "Group 57682",
    transform: "translate(5.516 5.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379280",
    "data-name": "Path 379280",
    d: "M129.5,118.5a2.7,2.7,0,0,1,.463.093,1.892,1.892,0,0,1-.417-.023A.1.1,0,0,1,129.5,118.5Z",
    transform: "translate(-129.5 -118.5)",
    fill: "#a90076",
    fillRule: "evenodd",
    opacity: 0.871,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57683",
    "data-name": "Group 57683",
    transform: "translate(2.74 5.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379281",
    "data-name": "Path 379281",
    d: "M69.5,136.492a.515.515,0,0,1,.324.093A.515.515,0,0,1,69.5,136.492Z",
    transform: "translate(-69.5 -136.492)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.878,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57684",
    "data-name": "Group 57684",
    transform: "translate(14.68 5.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379282",
    "data-name": "Path 379282",
    d: "M327.731,137.4a.526.526,0,0,1-.231.093A.212.212,0,0,1,327.731,137.4Z",
    transform: "translate(-327.5 -137.397)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.62,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57685",
    "data-name": "Group 57685",
    transform: "translate(3.064 5.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379283",
    "data-name": "Path 379283",
    d: "M76.5,138.5a1.017,1.017,0,0,1,.463.139A1.017,1.017,0,0,1,76.5,138.5Z",
    transform: "translate(-76.5 -138.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.914,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57686",
    "data-name": "Group 57686",
    transform: "translate(9.034 9.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379284",
    "data-name": "Path 379284",
    d: "M205.5,217.435a1.983,1.983,0,0,1,.6-.046v1.481h-.509a1.185,1.185,0,0,1,.463-.046v-1.388Z",
    transform: "translate(-205.5 -217.384)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.648,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57687",
    "data-name": "Group 57687",
    transform: "translate(14.448 10.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379285",
    "data-name": "Path 379285",
    d: "M323.981,232.527q-.742-.008-1.481.046a3.573,3.573,0,0,1,.9-.093A3.514,3.514,0,0,1,323.981,232.527Z",
    transform: "translate(-322.5 -232.48)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.573,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57688",
    "data-name": "Group 57688",
    transform: "translate(10.295 10.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379286",
    "data-name": "Path 379286",
    d: "M238.384,233.48a5.029,5.029,0,0,1,4.373,6.063q-.206.711-.463,1.388l2.684,2.684a1.793,1.793,0,0,0,.116.231v.417a1.3,1.3,0,0,1-.162.278q-.569.523-1.088,1.088a1.207,1.207,0,0,0-.278.162h-.417a1.788,1.788,0,0,0-.231-.116q-1.355-1.366-2.73-2.707a5.062,5.062,0,0,1-7.1-6.34,5.214,5.214,0,0,1,3.078-2.916.515.515,0,0,0,.324-.093.844.844,0,0,1,.417-.093Q237.642,233.473,238.384,233.48Zm-4.165,5.415a6.255,6.255,0,0,1,.046-1.018,3.5,3.5,0,0,1,2.777-2.892,3.6,3.6,0,0,1,2.684,6.572,3.636,3.636,0,0,1-4.79-.856A3.957,3.957,0,0,1,234.218,238.9Z",
    transform: "translate(-232.749 -233.48)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.998,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57689",
    "data-name": "Group 57689",
    transform: "translate(13.708 10.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379287",
    "data-name": "Path 379287",
    d: "M306.824,236.492a.515.515,0,0,1-.324.093A.515.515,0,0,1,306.824,236.492Z",
    transform: "translate(-306.5 -236.492)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.808,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57690",
    "data-name": "Group 57690",
    transform: "translate(6.766 13.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379288",
    "data-name": "Path 379288",
    d: "M156.5,309.5q.707.016,1.388.093A6.96,6.96,0,0,1,156.5,309.5Z",
    transform: "translate(-156.5 -309.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.49,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57691",
    "data-name": "Group 57691",
    transform: "translate(5.84 15.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379289",
    "data-name": "Path 379289",
    d: "M136.5,338.5q.486.023.972.069a.407.407,0,0,1,.185.069A7.368,7.368,0,0,1,136.5,338.5Z",
    transform: "translate(-136.5 -338.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.98,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57692",
    "data-name": "Group 57692",
    transform: "translate(7.182 13.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379290",
    "data-name": "Path 379290",
    d: "M166.472,311.5a7.473,7.473,0,0,1,.023,1.435.183.183,0,0,1-.093.046q-.461-.043-.9-.093h.972Z",
    transform: "translate(-165.5 -311.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.903,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57693",
    "data-name": "Group 57693",
    transform: "translate(11.717 14.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379291",
    "data-name": "Path 379291",
    d: "M263.581,328.5a6.261,6.261,0,0,0-.046,1.018,3.447,3.447,0,0,1-.023-.972A.1.1,0,0,1,263.581,328.5Z",
    transform: "translate(-263.488 -328.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.224,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57694",
    "data-name": "Group 57694",
    transform: "translate(5.609 18.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379292",
    "data-name": "Path 379292",
    d: "M131.5,400.5q1.234.146,2.453.231h-.139A11.535,11.535,0,0,1,131.5,400.5Z",
    transform: "translate(-131.5 -400.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.631,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57695",
    "data-name": "Group 57695",
    transform: "translate(7.923 18.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379293",
    "data-name": "Path 379293",
    d: "M183.166,405.981v-1.388a15.037,15.037,0,0,1-1.666-.046h.139q.789.015,1.574-.046A11.875,11.875,0,0,1,183.166,405.981Z",
    transform: "translate(-181.5 -404.5)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.645,
    "stoke-width": 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_57696",
    "data-name": "Group 57696",
    transform: "translate(5.192 19.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379294",
    "data-name": "Path 379294",
    d: "M122.5,430.4a.9.9,0,0,1,.509.093A2.494,2.494,0,0,1,122.5,430.4Z",
    transform: "translate(-122.5 -430.395)",
    fill: "",
    fillRule: "evenodd",
    opacity: 0.922,
    "stoke-width": 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.b876bc5a73447c3a100dfba8237b48bd.svg";
export { ForwardRef as ReactComponent };